export default __webpack_public_path__ + "static/media/toledo_2.dd7e4800.png";